import setMailboxRegionalConfigurationData from 'owa-service/lib/factory/setMailboxRegionalConfigurationData';
import setMailboxRegionalConfigurationOperation from 'owa-service/lib/operation/setMailboxRegionalConfigurationOperation';
import SetMailboxRegionalConfigurationResponse from 'owa-service/lib/contract/SetMailboxRegionalConfigurationResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function setMailboxRegionalConfiguration(
    timeZone: string
): Promise<SetMailboxRegionalConfigurationResponse> {
    try {
        return setMailboxRegionalConfigurationOperation({
            Header: getJsonRequestHeader(),
            Options: setMailboxRegionalConfigurationData({
                TimeZone: timeZone,
            }),
            SkipUserCultureCookies: false,
        });
    } catch {
        // Error handling with reject will be done later
        // https://outlookweb.visualstudio.com/Outlook%20Web/Outlook%20Web%20Team/_workitems/edit/33663
        return Promise.resolve({ WasSuccessful: false } as SetMailboxRegionalConfigurationResponse);
    }
}
